import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootState } from '../stores/store';
import { DashboardActions } from '../stores/dashboard/dashboard.actions';
import { EquipmentActions } from '../stores/equipment/equipment.actions';
import { AccountsActions } from '../stores/account/account.actions';
import { DealerActions } from '../stores/dealer/dealer.actions';
import { ApikeyActions } from '../stores/apikey/apikey.actions';
import { WebhookActions } from '../stores/webhook/webhook.actions';
import { ForwarderActions } from '../stores/forwarder/forwarder.actions';
import { ClickActions } from '../stores/click/click.actions';
import { EventActions } from '../stores/event/event.actions';
import { AppActions } from '../stores/app/app.actions';

@Injectable({
  providedIn: 'root'
})

export class StoreService {

  constructor(
    private store: Store<RootState>
  ) { }

  clearStore() {
    this.store.dispatch(DashboardActions.unsetDashboard());
    this.store.dispatch(EquipmentActions.unsetEquipmentStore());
    this.store.dispatch(AccountsActions.unsetAccountsStore());
    this.store.dispatch(DealerActions.unsetDealerStore());
    this.store.dispatch(ApikeyActions.unsetApikeyStore());
    this.store.dispatch(WebhookActions.unsetWebhookStore());
    this.store.dispatch(ForwarderActions.unsetForwarderStore());
    this.store.dispatch(ClickActions.unsetClickStore());
    this.store.dispatch(EventActions.unsetEventStore());
    this.store.dispatch(AppActions.setLoggedStatus({ loggedIn: false }));
  }
}
